<form [formGroup]="formdata" (ngSubmit)="submit()">
  <div>
    <app-custom-input
      [label]='"city"|translate'
      type="text"
      id="text"
      [placeholder]='"enterCity"|translate'
      formControlName="city"
    ></app-custom-input>
  </div>
  <div>
    <label
      for="street"
      class="block font-medium text-gray-700 dark:text-gray-200 font-auth mb-1"
    >
      {{ "street" | translate }}
    </label>
    <textarea
      pTextarea
      formControlName="street"
      [placeholder]='"enterStreet"|translate'
      rows="6"
      class="w-full min-h-[120px] md:min-h-[160px] lg:min-h-[200px] resize-none !border !border-[#D4D4D8] !rounded-xl"
    ></textarea>
  </div>
  <div>
    <app-customnumber
      [label]='"phone"|translate'
      id="phone"
      formControlName="phone"
    ></app-customnumber>
  </div>
  <button
    class="w-full mt-4 bg-[var(--navbar-light-coler)] text-white py-3 rounded-2xl disabled:bg-gray-400"
    type="submit"
    [disabled]="!formdata.valid"
  >
 {{'next'|translate}}
  </button>
</form>
